import { useState } from "react";
import _ from "lodash";

import VariableDesignerModal from "./VariableDesignerModal";
import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ActionButton from "../Commons/ActionButton";
import ListComponent from "../Commons/ListComponent";
import Pagination from "../Commons/Pagination";
import ListFilter from "../Commons/ListFilter";
import { applyListFilter, applyListSort, applyListFilterAndSort } from "../../tools/GeneralHelper";
import { variableValidator } from "../../tools/variableValidator";

import { MdAdd } from "react-icons/md";
import { getLabel } from "../../tools/Dictionary";
import "./VariableDesigner.css";

const VariableDesigner = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const OnCloseModal = props.OnCloseModal;
  const Variable = props.Variable;
  const VariableType = props.VariableType;
  const ProcessId = props.ProcessId;
  //const LoadData = props.LoadData;
  const Step = props.Step;
  const InitScript = props.InitScript;
  const OnConfirm = props.OnConfirm;
  const TempId = props.TempId;
  const SetTempId = props.SetTempId;

  const [loading] = useState(false);
  const [modal, setModal] = useState({
    id: 0,
    display: false
  });
  const [variable, setVariable] = useState([]);
  const [currentVariable, setCurrentVariable] = useState([]);
  const [column, setColumn] = useState([
    {
      label: getLabel("T_Variable", "name"),
      property: "name",
      style: { width: "25%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "35%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Variable", "description"),
      property: "description",
      style: { width: "25%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Variable", "variableTypeLabel"),
      property: "variableTypeLabel",
      style: { width: "15%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "30%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Variable", "dataToDisplay"),
      property: "dataToDisplay",
      style: { width: "25%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "35%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Variable", "order"),
      property: "order",
      style: { width: "10%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    }
  ]);
  const [sort, setSort] = useState({
    property: "",
    direction: 0 // Desc = 0, Asc = 1
  });
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10
  });
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useMount(() =>
  {
    fillData();
  }, []);

  const loadData = async() => {

    //const tempVariable = await LoadData();

    await fillData(Variable);

  };

  const fillData = async(_variable = undefined) => {


    let loadedVariable = applyListFilterAndSort(_variable ? _variable : Variable, column, sort);

    setVariable(loadedVariable);
    checkDataUpdateForPagination(loadedVariable, pagination);

  };

  const checkDataUpdateForPagination = (_data, _pagination, _resetPage = false) =>
  {

    let tempData = _data.filter(d => !d.bFiltered);
    let maxPage = Math.ceil(tempData.length / _pagination.perPage);
    let currentPage = _pagination.page;

    if (_resetPage)
      currentPage = 1;
    else if (_pagination.page > maxPage)
    {
      currentPage = maxPage > 0 ? maxPage : 1;
    }

    setCurrentVariable(sliceDataForPagination(_data, currentPage));

    setPagination(pagination => ({
      ...pagination,
      page: currentPage
    }));
  };

  const sliceDataForPagination = (_data, _page) =>
  {

    return _data.filter(d => !d.bFiltered).slice(pagination.perPage * (_page - 1), pagination.perPage * (_page - 1) + pagination.perPage);

  };

  const onClickSort = (_sort) =>
  {

    let tempData = applyListSort(variable, _sort);

    setVariable(tempData);
    checkDataUpdateForPagination(tempData, pagination);
    setSort(_sort);

  };

  const onApplyFilter = (_column) =>
  {

    let tempData = applyListFilter(variable, _column);

    setVariable(tempData);
    checkDataUpdateForPagination(tempData, pagination, true);
    setColumn(_column);

  };



  const onChangePage = (_page) =>
  {

    let tempPagination = {
      ...pagination,
      page: _page
    };

    checkDataUpdateForPagination(variable, tempPagination);

  };

  const onClickItem = (_item) =>
  {

    setModal({
      id: _item._id,
      display: true
    });

  };

  const onClickNew = () => {

    setModal({
      id: 0,
      display: true
    });
  
  }

  const onDuplicate = async(_data) => {



    let name = _data.name;
    let counter = 1;

    //Find the next available name
    // eslint-disable-next-line no-loop-func
    while (variable.some(v => v.name === name))
    {
      name = _data.name + counter;
      counter++;
    }


    _data._id = 0;
    //_data.name = name;
    _data.order = Math.max(...variable.map(v => v.order)) + 10;

    setModal({
      id: 0,
      display: true,
      duplicate: _data
    });

  };

  const validateVariableChange = (_data, _nameChange, _typeChange) => {

    

    return variableValidator(_data, InitScript, Step);


  };


  const onConfirm = (_data, isDelete = false) => {

    try{

      const updatedVariable = _.cloneDeep(Variable);

      let indexVariable = updatedVariable.findIndex(v => v._id == _data._id);

      //If Not a delete, replace the value for _data.dataToDisplay, as it's a calculated field.
      if (!isDelete){

        if (_data.variableTypeCode == "int" || _data.variableTypeCode == "number" || _data.variableTypeCode == "text")
        {
          _data.dataToDisplay = _data.data;
        } else if (_data.variableTypeCode == "table" || _data.variableTypeCode == "sensor")
        {
          _data.dataToDisplay = "[...]";
        } else
        {
          _data.dataToDisplay = "";
        }

      }

      if (indexVariable > -1)
      {

        //If need to be deleted
        if (isDelete) updatedVariable.splice(indexVariable, 1);
        else{
          updatedVariable[indexVariable] = _data;
          updatedVariable[indexVariable].isChanged = true;
        }


      } else
      {

        _data._id = TempId;
        SetTempId(TempId - 1);
        _data.isAdded = true;

        updatedVariable.push(_data);

      }

      OnConfirm(updatedVariable);
      fillData(updatedVariable);


    }catch(err){

      throw err;

    }


  };



  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "1200px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        {modal.display && 
          <VariableDesignerModal 
            IsDesktop={IsDesktop}
            Id={modal.id}
            Access={Access}
            ReadOnly={ReadOnly}
            OnCloseModal={() => setModal({ id: 0, display: false })}
            Variable={Variable}
            VariableType={VariableType}
            ProcessId={ProcessId}
            LoadData={loadData}
            NextOrder={variable.length > 0 ? Math.max(...variable.map(v => v.order)) + 10 : 10}
            OnDuplicate={onDuplicate}
            DuplicateData={modal.duplicate}
            ValidateVariableChange={validateVariableChange}
            OnConfirm={onConfirm}
          />
        }
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("VariableDesigner", "Variable Designer")}
        </div>
        <div className="page_modal_body_cont">
          <div className="variabledesigner_action_cont">
            <div className="page_action_cont" style={{ width: "90%", maxWidth: "1200px" }}>
              <div className="page_action_section" style={{ width: "30%" }}>
                {(Access.canWrite && !ReadOnly) &&
                  <ActionButton
                    IsDesktop={IsDesktop}
                    Label={getLabel("App", "New")}
                    Icon={MdAdd}
                    Disabled={loading}
                    OnClick={onClickNew}
                  />
                }
              </div>
              <div className="page_action_section" style={{ width: "40%", justifyContent: "center" }}>
                <Pagination
                  IsDesktop={IsDesktop}
                  data={pagination}
                  onChangePage={onChangePage}
                  count={variable.filter(p => !p.bFiltered).length}
                />
              </div>
              <div className="page_action_section" style={{ width: "30%", justifyContent: "right" }}>
                <ListFilter
                  IsDesktop={IsDesktop}
                  column={column}
                  Data={variable}
                  OnApplyFilter={onApplyFilter}
                />
              </div>
            </div>
          </div>
          <div className="variabledesigner_list_cont">
            <ListComponent
              IsDesktop={IsDesktop}
              Column={column}
              Data={currentVariable}
              Sort={sort}
              ListStyle={{ width: "96%", maxWidth: "1200px" }}
              Loading={loading}
              Debug={false}
              OnClickSort={onClickSort}
              OnClickItem={onClickItem}
            />
          </div>

        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default VariableDesigner